'use es6';

export const PUBLISHED_PAGE = 'publishedPage';
export const DRAFT_PAGE = 'draftPage';
export const SENT_EMAIL = 'sentEmail';
export const DRAFT_EMAIL = 'draftEmail';
export const BLOG = 'blog';
export const BLOG_POST_TEMPLATE = 'blogPostTemplate';
export const BLOG_LISTING_TEMPLATE = 'blogListingTemplate';
export const CODED_FILE = 'code';
export const CUSTOM_WIDGET = 'customModule';
export const EMAIL_TEMPLATE = 'emailTemplate';
export const PAGE_TEMPLATE = 'pageTemplate';
export const SYSTEM_TEMPLATE = 'systemTemplate';
export const QUOTE_TEMPLATE = 'quoteTemplate';
export const GLOBAL_GROUP = 'globalGroup';
export const CONTENT_SETTINGS = 'contentSettings';
export const GLOBAL_CONTENT_PARTIAL = 'globalContentPartial';
export const SALES_QUOTE_TEMPLATE = 'salesQuoteTemplate';